import { Component, OnInit } from '@angular/core';
import { LabelInterface } from './label.interface';
import { LabelService } from '../services';
import { UntypedFormControl } from '@angular/forms';
// // import { MAT_DATE_FORMATS } from '@angular/material/core';
// import { MatDatepicker } from '@angular/material/datepicker';
// import * as _moment from 'moment';
// // tslint:disable-next-line:no-duplicate-imports
// import { Moment } from 'moment';

// const moment = _moment;

// // See the Moment.js docs for the meaning of these formats:
// // https://momentjs.com/docs/#/displaying/format/
// export const MY_FORMATS = {
//   parse: {
//     dateInput: 'MM.YYYY',
//   },
//   display: {
//     dateInput: 'MM.YYYY',
//     monthYearLabel: 'MMM YYYY',
//     dateA11yLabel: 'LL',
//     monthYearA11yLabel: 'MMMM YYYY',
//   },
// };

@Component({
  selector: 'app-label',
  templateUrl: './label.component.html',
  styleUrls: ['./label.component.scss']
})
export class LabelComponent implements OnInit {

  label: LabelInterface = {
    id: 15,
    place: 'KA',
    info: 'Länge: 5m',
    date: new Date(),
    type: '25x70_25x17'
  };

  // date = new FormControl(moment(this.label.date));
  date = new UntypedFormControl(this.label.date);

  constructor(private labelService: LabelService) {
    this.date.valueChanges.subscribe(
      (data) => { this.label.date = data; }
    );
  }

  ngOnInit() {
  }

  // chosenYearHandler(normalizedYear: Moment) {
  //   const ctrlValue = this.date.value;
  //   ctrlValue.year(normalizedYear.year());
  //   this.date.setValue(ctrlValue);
  //   this.label.date = ctrlValue.toDate();
  // }

  // chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
  //   const ctrlValue = this.date.value;
  //   ctrlValue.month(normalizedMonth.month());
  //   this.date.setValue(ctrlValue);
  //   this.label.date = ctrlValue.toDate();
  //   datepicker.close();
  // }

  printLabel() {
    this.labelService.printLabel(this.label).subscribe();
  }

}
